export const PlanProductID = {
  ONE_MONTH: "one_month_renewable",
  THREE_MONTHS: "three_month_renewable",
  SIX_MONTHS: "six_month_renewable",
  LIGHT_ONE_MONTH: "premium_light",
};

export let premiumOptionsDefault = [
  {
    planId: 0,
    subscriptionPlans: [
      {
        price: "79.9",
        subscriptionPeriod: 1,
        planDescription: "מתחדש מידי חודש",
        generalProductId: PlanProductID.ONE_MONTH,
        androidProductId: "one_month_renewable_sub",
        appleProductId: "one_month_renewable_sub_ios",
      },
      {
        price: "59.9",
        subscriptionPeriod: 3,
        planDescription: 'סה"כ 179.90 שקלים, מתחדש כל שלושה חודשים',
        generalProductId: PlanProductID.THREE_MONTHS,
        androidProductId: "three_month_renewable_sub",
        appleProductId: "three_month_renewable_sub_ios",
      },
      {
        price: "39.9",
        subscriptionPeriod: 6,
        planDescription: 'סה"כ 239 שקלים, מתחדש כל חצי שנה',
        generalProductId: PlanProductID.SIX_MONTHS,
        androidProductId: "six_month_renewable_sub",
        appleProductId: "six_month_renewable_sub_ios",
      },
    ],
    // price: "79.90",
    currencyDescription: "₪",
    periodDescription: "לחודש",
    // subscriptionPeriod: 1,
    isLight: false,
    image: "assets/images/logo_sh_premium.svg",
    discount: null,
    // androidProductId: "one_month_renewable_sub",
    // appleProductId: "one_month_renewable_sub_ios",
    show: true,
    planName: "premium",
  },
  {
    planId: 1,
    subscriptionPlans: [
      {
        price: "29.9",
        subscriptionPeriod: 1,
        planDescription: "מתחדש מידי חודש",
        generalProductId: PlanProductID.LIGHT_ONE_MONTH,
        androidProductId: "premium_and_premium_light",
        appleProductId: "premium_light_ios",
      },
    ],
    // price: "29.90",
    currencyDescription: "₪",
    periodDescription: "לחודש",
    // subscriptionPeriod: 1,
    isLight: true,
    image: "assets/images/logo_sh_light.svg",
    discount: null,
    // androidProductId: "premium_and_premium_light",
    // appleProductId: "premium_light_ios",
    show: true,
    planName: "light",
  },
];

// export let premiumOptionsDefault = [
//     {
//       planId: 0,
//       price: "79.90",
//       currencyDescription: "שקלים לחודש",
//       subscriptionPeriod: 1,
//       isLight: false,
//       image: "assets/images/logo_sh_premium.svg",
//       discount: null,
//       androidProductId: "one_month_renewable_sub",
//       appleProductId: "one_month_renewable_sub_ios",
//       show: true,
//       planName: "premium",
//     },
//     {
//       planId: 1,
//       price: "29.90",
//       currencyDescription: "שקלים לחודש",
//       subscriptionPeriod: 1,
//       isLight: true,
//       image: "assets/images/logo_sh_light.svg",
//       discount: null,
//       androidProductId: "premium_and_premium_light",
//       appleProductId: "premium_light_ios",
//       show: true,
//       planName: "light",
//     },
//   ];
